export const orgKeys = {
	all: ['org'],
	info: () => [...orgKeys.all, 'info'],
	members: () => [...orgKeys.all, 'members'],
	membersBasic: () => [...orgKeys.all, 'membersBasic'],
	credits: () => [...orgKeys.all, 'credits'],
	pendingInvites: () => [...orgKeys.all, 'pending-invites'],
};
